export default "<div class=\"pulse-container\">\r\n  <div class=\"dot\"></div>\r\n  <div class=\"dot\"></div>\r\n  <div class=\"dot\"></div>\r\n</div>\r\n";